import axios from 'axios';
import { requestFcmWebToken, onForegroundMessage } from '../firebase';
import { isTossitNativeApp } from './nativeBridge';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Retrieve an FCM web token and register it with the backend for the logged-in user.
// No-ops in the native app (host handles push) or if permission/VAPID/token is unavailable.
export const registerFcmToken = async (authToken) => {
  try {
    if (!authToken || isTossitNativeApp()) return;
    if (typeof Notification !== 'undefined' && Notification.permission === 'denied') return;
    const fcmToken = await requestFcmWebToken();
    if (!fcmToken) return;
    await axios.post(
      `${API_URL}/api/auth/fcm-token`,
      { token: fcmToken, platform: 'web' },
      { headers: { Authorization: `Bearer ${authToken}` } }
    );
  } catch (e) {
    // Silent — push registration is best-effort.
  }
};

// Register an FCM web token for a logged-in COOK (iOS-compatible push via Firebase).
// Posts to /api/cook/fcm-token. No-ops in the native app or if token unavailable.
export const registerCookFcmToken = async (cookToken) => {
  try {
    if (!cookToken || isTossitNativeApp()) return;
    if (typeof Notification !== 'undefined' && Notification.permission === 'denied') return;
    const fcmToken = await requestFcmWebToken();
    if (!fcmToken) return;
    await axios.post(
      `${API_URL}/api/cook/fcm-token`,
      { token: fcmToken, platform: 'web' },
      { headers: { Authorization: `Bearer ${cookToken}` } }
    );
  } catch (e) {
    // Silent — push registration is best-effort.
  }
};

// Show foreground pushes as an in-app notification (browser suppresses them otherwise).
export const listenForegroundPush = async () => {
  try {
    return await onForegroundMessage((payload) => {
      const n = payload?.notification || payload?.data || {};
      if (n.title && typeof Notification !== 'undefined' && Notification.permission === 'granted') {
        new Notification(n.title, { body: n.body || '', icon: '/icon-192.png' });
      }
    });
  } catch (e) {
    return () => {};
  }
};
